var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "subject",
      class: [_vm.isIndex ? "is-index" : ""],
      style: {
        backgroundColor:
          _vm.themeConfig && _vm.themeConfig.web_theme_background_color
            ? _vm.themeConfig.web_theme_background_color
            : "none"
      }
    },
    [
      _vm.themeConfig && _vm.themeConfig.web_theme_top_img
        ? _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _c("img", {
              staticClass: "theme-top-img",
              attrs: { src: _vm.themeConfig.web_theme_top_img, alt: "" },
              on: { click: _vm.topImgClick }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.clientId == 320684
        ? _c("div", {
            staticClass: "jdqz",
            staticStyle: {
              background:
                "url('/public/w/img/410600/znq.png') no-repeat top center",
              width: "100%",
              height: "576px !important"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { position: "relative" } },
        [
          _c("LayoutHeader", {
            attrs: {
              channels: _vm.channels,
              ads: _vm.ads,
              showid: _vm.showid,
              clientId: _vm.clientId,
              apiOrigin: _vm.apiOrigin
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main clear  contents pt30" },
            [_vm._t("main")],
            2
          ),
          _vm._v(" "),
          _vm.clientId == 320598
            ? _c("div", { staticClass: "aside_img_lf" })
            : _vm._e(),
          _vm._v(" "),
          _vm.clientId == 320598
            ? _c("div", { staticClass: "aside_img_rh" })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("LayoutFooter", { attrs: { clientId: _vm.clientId } }, [
        _c(
          "div",
          { attrs: { slot: "bottom" }, slot: "bottom" },
          [_vm._t("bottom")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-25f71788", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f71788","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/component/web/news-layout/main.vue
// module id = null
// module chunks = 